import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { hasSobCompetitorsStep } from 'partner360/components/QBR/helpers/hasSobCompetitorsStep'
import {
  changeQBRLastStep,
  selectQBRDocumentFormData,
  selectQBROfferings,
  selectQBRPartners,
} from 'partner360/features/QBR'

import { IOnStepChangeFn, Navigation } from '../../../navigation'
import { selectQbrSettingsForm } from '../steps/settingsStep/components/qbrSettingsForm/selectors/selectQbrSettingsForm'

import { QBR_DOCUMENT_DETAILS_STEPS, QBR_DOCUMENT_DETAILS_WITH_COMPETITORS } from './configs'

interface IQbrDocumentDetailsNavigationProps {
  currentStep: number
}

export const QbrDocumentDetailsNavigation = ({
  currentStep,
}: IQbrDocumentDetailsNavigationProps) => {
  const documentFormData = useSelector(selectQBRDocumentFormData)
  const qbrSettingsForm = useSelector(selectQbrSettingsForm)
  const qbrOfferings = useSelector(selectQBROfferings)
  const qbrPartners = useSelector(selectQBRPartners)
  const dispatch = useAppDispatch()

  const steps = useMemo(() => {
    if (hasSobCompetitorsStep(qbrPartners, qbrOfferings)) {
      return QBR_DOCUMENT_DETAILS_WITH_COMPETITORS
    }
    return QBR_DOCUMENT_DETAILS_STEPS
  }, [qbrOfferings, qbrPartners])

  const isQbrSettingsStep = useMemo(() => currentStep === 1, [currentStep])
  const isQbrSettingsChanged = useMemo(
    () => (qbrSettingsForm ? qbrSettingsForm.modifiedFields.length > 0 : false),
    [qbrSettingsForm]
  )

  const onStepChange = useCallback<IOnStepChangeFn>(
    (newStep) => () => {
      dispatch(changeQBRLastStep(newStep))
    },
    [dispatch]
  )

  return (
    <Navigation
      steps={steps}
      currentStep={currentStep}
      onStepChange={onStepChange}
      isDisabled={!documentFormData || (isQbrSettingsStep && isQbrSettingsChanged)}
    />
  )
}
